import { render } from "./OrderDetailsActionButtons.vue?vue&type=template&id=4803154a"
import script from "./OrderDetailsActionButtons.vue?vue&type=script&lang=js"
export * from "./OrderDetailsActionButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__